exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gl-card-disabled[data-v-55965fd5] .ant-card-head-title { color: #999;\n}\n", ""]);

// exports
